<template>
  <div v-if="this.checkMobile()" class="grey-background-container">
    <MobileNavigationBack
      :moduleRoute="moduleRoute"
      :appbarTitle="moduleRoute"
    ></MobileNavigationBack>
    <br />
    <br />

    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 mb-5 pb-2">
      <MobileBsIndex :routeDef="moduleRoute" :headersDef="headers">
      </MobileBsIndex>
    </div>

    <div
      v-if="moduleRoute === 'users'"
      class="grid grid-cols-6 gap-1 text-center mt-1 mb-1"
    >
      <!-- If users then nothing will be rendered -->
    </div>

    <div
      v-else-if="moduleRoute === 'audits'"
      class="grid grid-cols-6 gap-1 text-center mt-1 mb-1"
    >
      <!-- If audits then nothing will be rendered -->
    </div>

    <jet-nav-link
      v-else
      @click="goToCreate"
      class="fixed bottom-0 right-0 mb-4 mr-4 hover:no-underline"
    >
      <div
        class="bg-blue-500 p-3 hover:cursor-pointer rounded-full shadow"
        style="display: inline-block"
      >
        <i
          class="fas fa-plus text-white text-xl d-flex justify-content-center"
        ></i>
      </div>
    </jet-nav-link>
  </div>
  <div v-else>
    <app-layout :title="title">
      <template v-slot:sidenav> </template>

      <template v-slot:horizonav>
        <nav-bar :scId="currentProduct" scType="product"> </nav-bar>
      </template>
      <PageTitle :headerTitle="title"> </PageTitle>
      <div>
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
          <div>
            <div>
              <div class="row">
                <div class="col">
                  <!-- Add Button - START -->
                  <div
                    v-if="moduleRoute === 'users'"
                    class="grid grid-cols-6 gap-1 text-center mt-1 mb-1"
                  >
                    <!-- If users then nothing will be rendered -->
                  </div>

                  <div
                    v-else-if="moduleRoute === 'audits'"
                    class="grid grid-cols-6 gap-1 text-center mt-1 mb-1"
                  >
                    <!-- If audits then nothing will be rendered -->
                  </div>

                  <div v-else>
                    <jet-button
                      class="
                        bg-blue-500
                        rounded
                        text-white
                        hover:bg-blue-500 hover:no-underline
                        px-2
                        cursor-pointer
                        text-sm
                      "
                      @click="goToCreate"
                    >
                      Add {{ moduleLabel }}</jet-button>

                    <jet-button @click="goToCreate" class="bg-blue-500 rounded text-white hover:bg-blue-500 hover:no-underline px-2 cursor-pointer text-sm">
                      Publish Updates
                    </jet-button>  
                    <!-- Add Button - END -->

                     <nav-link
                      v-if="!itemSelected"
                      class="
                        text-gray-400
                        float-right
                        hover:no-underline
                        cursor-pointer
                      "
                       
                      ><i class="fa fa-trash fa-lg" aria-hidden="true"></i></nav-link>

                    <nav-link
                  
                      v-if="itemSelected"
                      class="
                  
                        text-red-500
                        float-right
                        hover:no-underline
                        cursor-pointer
                      "
                      @click="deleteMulti"
                      ><i class="fa fa-trash fa-lg" aria-hidden="true"></i></nav-link>
                  </div>
                </div>
              </div>
              <div class="mt-2">
                <div
                  class="
                    bg-white
                    overflow-hidden
                    shadow-xl
                    px-2
                    py-2
                    sm:rounded-lg
                  "
                >
                  <BsIndex
                    @item_selected="OnItemSelected"
                    :routeDef="moduleRoute"
                    :slug="slug"
                    :headersDef="headers"
                  >
                  </BsIndex>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </app-layout>
  </div>
</template>

<style>
.grey-background-container {
  background-color: #ffffff;
  height: 100%;
}
</style>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import BsIndex from "@/Base/BsIndex.vue";
import MobileBsIndex from "@/Base/MobileBsIndex.vue";
//import { DxDataGrid } from 'devextreme-vue/data-grid';
import DataSource from "devextreme/data/data_source";
import "devextreme/data/odata/store";
import PageTitle from "@/Layouts/PageTitle.vue";
import JetNavLink from "@/Jetstream/NavLink.vue";
import JetButton from "@/Jetstream/Button.vue";
import MobileNavigation from "@/Layouts/MobileNavigation.vue";
import MobileNavigationBack from "@/Layouts/MobileNavigationBack.vue";
import NavBar from "@/Layouts/NavBar.vue";

let collapsed = false;

export default {
  props: {
    moduleRoute: String,
    slug: String,
    currentProduct: String,
    headers: Array,
    moduleName: String,
    moduleLabel:String,
  },
  components: {
    AppLayout,
    BsIndex,
    PageTitle,
    JetNavLink,
    JetButton,
    MobileNavigation,
    MobileBsIndex,
    MobileNavigationBack,
    NavBar,
  },
  data() {
    return {
      title: this.moduleLabel,
      appbarTitle: this.moduleRoute,
      itemSelected: false,
      selectedArr: [],
    };
  },
  methods: {
    sayHelloWorld() {
      alert("Hello world!");
    },
    goToCreate() {



      this.$inertia.get("/" + this.slug + "/" + this.moduleRoute + "/create");
      //   this.$inertia.get( this.moduleRoute + '/create');
    },
    deleteMulti(){
     
      this.$inertia.get(route( this.moduleRoute+".mutlidelete", [this.slug,this.selectedArr]));
      
    },


    checkMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        console.log("CheckMobile Called: Mobile");
        return true;
      } else {
        console.log("CheckMobile Called: Desktop");
        return false;
      }
    },

    OnItemSelected(selectedValue) {
     // console.log("On Item Selected", selectedValue);
      this.selectedArr = selectedValue;
      if(this.selectedArr.length){
        this.itemSelected = true;
      }
      else{
        this.itemSelected = false;
      }
     
      console.log("ARR VALUE", this.selectedArr);
    },
  },

  mounted() {
    // this.checkMobile();
    // console.log("PRODC ID", this.prodId);
  },
};
</script>
